export const Color = {
    primary: '#164E62',
    white: '#FFF',
    black: '#000',
    grey: '#FEFEFE',
    datatableFontColor: 'rgba(0, 0, 0, 0.6)',
    borderColor: '#CCCCCC'
}